/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.1.4
 */
import Tool from './Tool'
//
let { Polygon } = L;
/**
 * 多边形绘制工具
 */
export default class PolygonTool extends Tool {
  marker
  mp // move point
  options = { feature: { color: 'red', fillOpacity: .5, weight: 1 } }
  /**
   * 
   */
  start() {
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    //
    let { map } = this;
    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;
  }
  /**
   * 
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null
  }
  /**
   * 
   */
  onMouseDown(e) {
    this.reset();
    //
    let { marker, map, layer, options } = this;
    let { latlng } = e;
    if (!marker) {
      marker = this.marker = new Polygon([latlng], options.feature).addTo(layer)
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this))
    }
    this.mp = null;
  }
  /**
   * 
   */
  onMouseMove(e) {
    let { marker, mp } = this;
    let { latlng } = e;
    if (!mp) {
      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      marker.getBounds().extend(mp)
      marker.redraw();
    }
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/PolygonTool.js